import {
  Select,
  Typography,
  Stack,
  tokens,
  colorOrToken,
} from '@cast/design-system';

import { TimeInput } from './TimeInput';
import { weekDays, WeekState } from '../_types';
import { useInputs } from '../useInputs';

export const WeekInput = () => {
  const { state, setState, isView } = useInputs<WeekState>();
  const noWeekdaySelection = state.on.length === 0;

  return (
    <Stack gap={4}>
      <Stack gap={8} display="grid" gridTemplateColumns="1fr 1fr">
        <Select
          inputProps={{ label: 'On:' }}
          options={weekDays}
          value={state.on}
          checkable
          multiple
          inputText={`${noWeekdaySelection ? 'Select' : 'Selected'} days`}
          onChange={(value) =>
            setState((state) => {
              return { ...state, on: value };
            })
          }
          disabled={isView}
          testId="week-select"
          applySortingWhileSearching={false}
        />

        <TimeInput
          time={state.at}
          onTimeChange={(newTime) =>
            setState((state) => ({ ...state, at: newTime }))
          }
          label="At:"
          InputProps={{
            readOnly: isView || noWeekdaySelection,
            testId: 'time-input',
          }}
          sx={{ width: '100%' }}
        />
      </Stack>
      {noWeekdaySelection && (
        <Typography
          variant="P12R"
          color={colorOrToken('red.500', tokens.theme.fg.status.error)}
        >
          Weekday is required
        </Typography>
      )}
    </Stack>
  );
};
